export default __webpack_public_path__ + "static/media/Lavamanos Sencillo.58737fef.png";